module.exports = __webpack_public_path__ + "media/src/images/icons/download-0041cd433eea1442070e5f26363c2988.svg";